import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs, Spacer, StackView, Typography } from '@telus-uds/components-web';
import { RichText } from '../RichText/RichText';
import { PageTitleStyledCuts } from './PageTitleStyledCuts/PageTitleStyledCuts';
var renderSubHead = function (subhead) {
    if (!subhead) {
        return null;
    }
    if (typeof subhead === 'string') {
        return (_jsx(Typography, { block: true, variant: { size: 'medium' }, children: subhead }));
    }
    if (typeof subhead === 'object') {
        return _jsx(RichText, { content: subhead });
    }
    return null;
};
export var PageTitle = function (_a) {
    var headline = _a.headline, headline2 = _a.headline2, theme = _a.theme, breadcrumbs = _a.breadcrumbs, subhead = _a.subhead;
    return (_jsx(PageTitleStyledCuts, { theme: theme, children: _jsxs(StackView, { direction: 'column', space: { xs: 4, lg: 5 }, children: [breadcrumbs && _jsx(Breadcrumbs, { routes: breadcrumbs }), _jsxs(StackView, { children: [_jsxs(Typography, { block: true, variant: { size: 'h1' }, heading: "h1", children: [headline, headline2 && _jsx("br", {}), headline2] }), subhead && _jsx(Spacer, { space: 2 }), renderSubHead(subhead)] })] }) }));
};
